import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["data-id"]

import { ref, onMounted, nextTick } from "vue";

import { getClasses } from "~/js/composables/classes";

import { Image } from "~/js/interfaces/media";

import ImageTeaser from "~/vue/atoms/images/ImageTeaser.vue";
import LightboxImage from "~/vue/organisms/lightboxes/LightboxImage.vue";
import ButtonPrimary from "~/vue/atoms/buttons/ButtonPrimary.vue";

interface Props {
	image: Image | null;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LightboxFloorplan',
  props: {
    image: { default: null },
    utilities: { default: "" }
  },
  setup(__props: any) {



const activeId = ref(null);
const activeBounding = ref(null);
const gridBounding = ref(null);
const activeElement = ref(null);
const gridElement = ref(null);

const classes = ref({
	wrapper: {
		grid: "grid grid-cols-1",
		size: "w-full",
	},
	button: {
		display: "block",
		focus: "focus:ring-4 focus:ring-celestial-500 focus:outline-none focus:text-viridian-700",
		layout: "rounded-3xl",
		position: "relative",
		size: "w-full h-full",
	},
	aspect: {
		aspect: "aspect-[4/3]",
	},
	element: {
		animation: "transition-all duration-700",
		position: "absolute left-0 top-0",
	},
	activeElement: {
		position: "z-[60]",
		size: "w-[90vw] max-w-[750px]",
	},
	inactiveElement: {
		events: "pointer-events-none",
		size: "w-full",
	},
});

const onExpand = (id: number, i: number) => {
	activeId.value = `${id}${i}`;
	activeElement.value = document.querySelector(`[data-id="${id}${i}"]`);

	onResize();

	setTimeout(() => {
		window.scrollTo({
			top:
				activeBounding.value.y +
				window.scrollY -
				(window.innerHeight - activeElement.value.getBoundingClientRect().height) * 0.5,
			left: 0,
			behavior: "smooth",
		});
	}, 800);
};

const onHide = () => {
	if (activeElement.value) {
		activeElement.value.style.left = "0";
		activeElement.value.style.top = "0";
	}
	activeId.value = null;
	activeElement.value = null;
};

const onResize = () => {
	if (gridElement.value) {
		// gridBounding.value = gridElement.value.getBoundingClientRect()
		gridBounding.value = document.getElementById("locations-detail").getBoundingClientRect();
	}

	if (activeElement.value) {
		activeBounding.value = activeElement.value.parentElement.getBoundingClientRect();

		if (window.innerWidth > 750) {
			const elementWidth = window.innerWidth * 0.9 > 750 ? 750 : window.innerWidth * 0.9;
			activeElement.value.style.left = `${gridBounding.value.x - activeBounding.value.x - (elementWidth - gridBounding.value.width) * 0.5}px`;
			activeElement.value.style.top = `${gridBounding.value.y - activeBounding.value.y - (activeElement.value.height - gridBounding.value.width) * 0.5}px`;
		} else {
			activeElement.value.style.left = "0";
			activeElement.value.style.top = "0";
		}
	}
};

const onKeyboardStroke = (evt) => {
	if (evt.key === "Escape") {
		onHide();
	}
};

onMounted(() => {
	window.addEventListener("resize", onResize);
	window.addEventListener("keyup", onKeyboardStroke);
	onResize();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "gridElement",
    ref: gridElement,
    class: _normalizeClass([_unref(getClasses)(classes.value, 'wrapper'), "aspect-[4/3]"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(_unref(getClasses)(classes.value, 'button')),
        onClick: _cache[0] || (_cache[0] = () => onExpand(__props.image.id, 0))
      }, [
        _createVNode(ImageTeaser, {
          image: __props.image.image,
          sizes: ['(max-width: 640px) 100vw', '(min-width: 640px and max-width: 768px) 50vw'],
          ratio: _unref(getClasses)(classes.value, 'aspect'),
          utilities: "absolute left-0 top-0 w-full h-full rounded-3xl overflow-hidden"
        }, null, 8, ["image", "ratio"]),
        _createVNode(ButtonPrimary, {
          type: "span",
          icon: "maximize",
          utilities: "absolute right-2 bottom-2"
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass([
					_unref(getClasses)(classes.value, 'element'),
					activeId.value == `${__props.image.id}0`
						? _unref(getClasses)(classes.value, 'activeElement')
						: _unref(getClasses)(classes.value, 'inactiveElement'),
				]),
        "data-id": `${__props.image.id}0`,
        tabindex: "-1"
      }, [
        (activeId.value == `${__props.image.id}0`)
          ? (_openBlock(), _createBlock(LightboxImage, {
              key: 0,
              image: __props.image.image,
              utilities: activeId.value == `${__props.image.id}0` ? 'opacity-100' : 'opacity-0',
              tabindex: "-1",
              onHide: onHide
            }, null, 8, ["image", "utilities"]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2)
    ])
  ], 2))
}
}

})